import { useDrag } from 'react-dnd'

import { Box } from '@factorialco/deprecated-design-system'
import { SignerStampItemFragment } from 'generated/resources/graphql'

import SignerStamp from 'modules/documents/components/EsignaturePlacementFile/SignerStamp'
import { DropTypes } from 'modules/documents/components/EsignaturePlacementFile/constants'

interface Props {
  signer: SignerStampItemFragment
  isPending: boolean
  isError: boolean
  isSuccess: boolean
  signingOrder?: number
}

const DraggableStamp = ({ signer, isPending, isError, isSuccess, signingOrder }: Props) => {
  const [, drag] = useDrag(() => ({
    type: DropTypes.STAMP,
    item: { signerId: signer.id },
  }))

  return (
    <Box ref={drag}>
      <SignerStamp
        fullName={signer.fullName}
        avatar={signer.avatar || ''}
        jobTitle={signer.employee?.referenceContract?.jobTitle || ''}
        status={isError ? 'error' : isSuccess ? 'success' : 'default'}
        isPending={isPending}
        signingOrder={signingOrder}
      />
    </Box>
  )
}

export default DraggableStamp
